import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map, Observable, retry } from 'rxjs';
import { UserService } from './user.service';

export interface IItemOperationHierarchyNode {
	id: string;
	sourceId: string | null;
	nextId: string | null;
	alias: string;
	terminalId: string | null;
	batchId: string | null;
	detailAlias: string | null;
	group: string | null;
	layers: string | null;
}

export interface IItemOperationHierarchyResponse {
	result: IItemOperationHierarchyNode[];
	statusCode: number;
}

@Injectable({ providedIn: 'root' })
export class ItemOperationHierarchyService {
	constructor(
		private http: HttpClient,
		private userService: UserService,
	) {}

	getItemOperationHierarchy(id: string, fromEnd = true): Observable<IItemOperationHierarchyNode[]> {
		const url = `${environment.awsEnvUri}/mes/itemoperations/${id}/hierarchy?fromEnd=${fromEnd}`;
		return this.http.get<IItemOperationHierarchyResponse>(url, { headers: this.userService.getHeaders() }).pipe(
			retry(1),
			map((response) => response.result ?? []),
		);
	}
}
